import { render } from "./ListeTypeDocument.vue?vue&type=template&id=8fcc0880&ts=true"
import script from "./ListeTypeDocument.vue?vue&type=script&lang=ts"
export * from "./ListeTypeDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__